/**
 * Coerce FastAPI / fetch error payloads into a string the UI can show.
 *
 * FastAPI 422 bodies use `{ detail: [{ loc, msg, type, input }, ...] }`.
 * Passing that array through `${detail}` or `.trim()` yields `[object Object]`
 * or `trim is not a function`.
 */

const MAX_JSON_LENGTH = 500;

function locLabel(loc) {
    if (!Array.isArray(loc) || loc.length === 0) return '';
    return loc.filter((part) => part !== 'body' && part !== 'query').join('.');
}

export function formatApiErrorDetail(value) {
    if (value == null || value === '') return '';
    if (typeof value === 'string') return value.trim();
    if (typeof value === 'number' || typeof value === 'boolean') return String(value);
    if (Array.isArray(value)) {
        return value.map(formatApiErrorDetail).filter(Boolean).join('; ');
    }
    if (typeof value === 'object') {
        if (typeof value.msg === 'string') {
            const loc = locLabel(value.loc);
            return loc ? `${loc}: ${value.msg}` : value.msg;
        }
        if (value.detail !== undefined) return formatApiErrorDetail(value.detail);
        if (typeof value.message === 'string') return value.message;
        if (typeof value.error === 'string') return value.error;
        try {
            const json = JSON.stringify(value);
            if (json && json !== '{}') {
                return json.length > MAX_JSON_LENGTH ? `${json.slice(0, MAX_JSON_LENGTH)}…` : json;
            }
        } catch {
            return String(value);
        }
    }
    return String(value);
}
